import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
}

export function Logo({ className }: LogoProps) {
  const defaultSize = "h-16 w-auto mx-auto";
  return (
    <>
      <img
        src="/sabhia-dark.png"
        alt="Sabhia"
        className={cn(defaultSize, className, "dark:hidden")}
      />
      <img
        src="/sabhia-white.png"
        alt="Sabhia"
        className={cn(defaultSize, className, "hidden dark:block")}
      />
    </>
  );
}

